import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5fbba7de&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=5fbba7de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbba7de",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/var/www/app/components/Logo.vue').default,HeaderMenuLeft: require('/var/www/app/components/HeaderMenuLeft.vue').default,HeaderSearch: require('/var/www/app/components/HeaderSearch.vue').default,HeaderMobileSearch: require('/var/www/app/components/HeaderMobileSearch.vue').default,HeaderBasket: require('/var/www/app/components/HeaderBasket.vue').default,HeaderUser: require('/var/www/app/components/HeaderUser.vue').default,HeaderLogin: require('/var/www/app/components/HeaderLogin.vue').default,HeaderAdmin: require('/var/www/app/components/HeaderAdmin.vue').default,HeaderFavorites: require('/var/www/app/components/HeaderFavorites.vue').default,HeaderMobile: require('/var/www/app/components/HeaderMobile.vue').default,Header: require('/var/www/app/components/Header.vue').default})
